import { singleColor } from '@/lib/ui/colorPalletes';

const defaultFont = "WPP, 'Helvetica Neue', Helvetica, Arial, sans-serif";
class ChartTheme {
  lineColors = [];

  primaryColor = '#7c65a5';

  chartBackgroundColor = '#FFFFFF';

  guideColor = '#000000';

  font = defaultFont;

  constructor(lineColors = [], primaryColor = '#7c65a5', chartBackgroundColor = 'transparent') {
    this.lineColors = lineColors;
    this.primaryColor = primaryColor;
    this.chartBackgroundColor = chartBackgroundColor;
  }

  /**
   * Returns an array of single color
   * @param count{int}
   * @returns {*[string]}
   */
  singleColors(count) {
    const colors = singleColor(this.primaryColor)(count);
    return colors;
  }

  multipleColors() {
    return this.lineColors;
  }

  /**
   * Returns a factory that generates colors for a chart type
   * @param chartType
   * @returns {(function(int): *[])|(function(): [])}
   */
  palletFactory(chartType) {
    const multicolorCharts = {
      pie: true,
      'bubble-pack': true,
      time: true,
    };

    if (chartType in multicolorCharts) {
      return () => this.multipleColors();
    }

    return this.singleColors;
  }

  /**
   *
   * @param customizationSettings{AppObjectSetting}
   */
  setTheme(customizationSettings) {
    this.colors = customizationSettings?.list('chartColors');

    const primaryColor = customizationSettings?.getSetting('--chartPrimaryColor');
    this.primaryColor = primaryColor.value;

    const chartBackgroundColor = customizationSettings?.getSetting('--chart-background');
    this.chartBackgroundColor = chartBackgroundColor?.value;
  }
}

export default ChartTheme;

export const chartThemeFactory = (customizationSettings) => {
  const colors = customizationSettings?.list('chartColors');
  const primaryColor = customizationSettings?.getSetting('--chartPrimaryColor');
  const chartBackgroundColor = customizationSettings?.getSetting('--chart-background');
  const guideColor = customizationSettings?.getSetting('--chart-guide-color');
  const textFont = customizationSettings?.getSetting('--chart-text-font');

  const theme = new ChartTheme(colors, primaryColor?.value, chartBackgroundColor?.value);

  theme.guideColor = guideColor?.value;
  theme.font = textFont?.value || defaultFont;

  return theme;
};
